<template>
  <div>
    <div class="header-virtualization">
      <h1 class="title">{{ $t('flexben.beneficiary_pages.core_card_type.modal.title') }}</h1>
        <div class="clearfix"></div>
      <h3 class="title mt-3 mb-3">{{ $t('flexben.beneficiary_pages.core_card_type.modal.subtitle_regina_maria') }}</h3>
        <div class="clearfix"></div>
      <h3 class="title">{{ $t('flexben.beneficiary_pages.core_card_type.modal.subtitle') }}</h3>
    </div>
    <div class="card-selector">
      <div
        class="card"
        :class="{ active: selected_card_type === 1 }"
        @click="selectCardType(1)"
      >
        <img src="@/assets/images/svg/card_virtualization/physical_card.svg" alt="Card Virtual" class="icon" />
        <h3>{{ $t('flexben.beneficiary_pages.core_card_type.modal.card_selector.title_virtual') }} </h3>
        <p>{{ $t('flexben.beneficiary_pages.core_card_type.modal.card_selector.description_virtual') }} </p>
      </div>

      <div
        class="card"
        :class="{ active: selected_card_type === 2 }"
        @click="selectCardType(2)"
      >
        <img src="@/assets/images/svg/card_virtualization/virtual_card.svg" alt="Card Fizic" class="icon" />
        <h3>{{ $t('flexben.beneficiary_pages.core_card_type.modal.card_selector.title_physical') }} </h3>
        <p>{{ $t('flexben.beneficiary_pages.core_card_type.modal.card_selector.description_physical') }} </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "BenefitCoreCardTypeSelector",
  props: {
  },
  data() {
    return {
      selected_card_type: null,
    };
  },
  methods: {
    selectCardType(value) {
      this.selected_card_type = value;
      this.$emit('cardTypeSelected', value);
    }
  }
};
</script>

<style scoped>

.card-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

@media (min-width: 768px) {
  .card-selector {
    flex-direction: row;
    justify-content: center;
  }
}

.header-virtualization h1 {
  font-size: 30px;
  font-weight: bold;
  margin-top: 15px;
}

.header-virtualization h3 {
  font-size: 18px;
  margin: 10px 0;
}

.card {
  border: 2px solid #ccc;
  border-radius: 16px;
  padding: 20px;
  width: 280px;
  text-align: center!important;
  transition: all 0.3s ease;
  cursor: pointer;
  background-color: #fff;
  min-height: 230px;
  margin-top: 15px;
}

.card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card.active {
  border-color: orange;
}

.card .icon {
  width: 52px;
  height: 52px;
  display: block;
  margin: 0 auto;
}

.card h3 {
  font-size: 18px;
  margin: 7px 0;
  color: #111;
}

.card p {
  font-size: 12px;
  color: #555;
  margin-top: 10px;
}

</style>
